import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
  constructor(private slimLoadingBarService: SlimLoadingBarService) {
    
  }

  public continue(progress: number = 50): void {
    let current = this.slimLoadingBarService.progress;

    if (current < progress) {
      this.slimLoadingBarService.progress = progress;
      this.slimLoadingBarService.start();
    }
  }

  public stop(): void {
    this.slimLoadingBarService.stop();
  }

  public complete(): void {
    if (this.slimLoadingBarService.visible) {
      this.slimLoadingBarService.complete();
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/loading/loading-service.ts